// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nmw0","fullView":"styles_fullView__EKLjl"};